import * as React from 'react';
import {Route, Switch, useRouteMatch} from "react-router";
import SearchUsers from "./Search";
import AddUser from "./Add";



const ManageUsers: React.FunctionComponent = () => {
    let {path} = useRouteMatch();
    return (<>
        <Switch>

            <Route exact path={path}>
                <SearchUsers />
            </Route>
            <Route exact path={path + "/add"}>
                <AddUser />
            </Route>
        </Switch>
    </>);
};

export default ManageUsers;